import { connect } from "react-redux";
import ControlPanel from "./ControlPanel";
import { toggleIsHorizontal } from "../../Actions/settingsAction";

export default connect(
  (store) => ({
    isHorizontal: store.icoSettings.isHorizontal,
  }),
  (dispatch) => ({
    layoutToggleHandler: (isHorizontal) => dispatch(toggleIsHorizontal(isHorizontal)),
  })
)(ControlPanel);
